(() => {
  angular
    .module('gm.common.footer')
    .directive('gmyFooterLegal', gmyFooterLegal);

  function gmyFooterLegal(
    Environment
  ) {
    'ngInject';

    return {
      link,
      replace: true,
      restrict: 'E',
      templateUrl: 'modules/footer/directives/footer-legal/footer-legal.html',
    };

    function link(scope) {
      scope.siteUrl = Environment.urls.site;
      scope.year = new Date().getFullYear();
    }
  }
})();
